export const STORAGE_URL = "https://storage.googleapis.com/3d-container/";
